import { IRefreshAdsInterval } from '../services/ad-services/ad-services.types';

export const AD_CONSOLE_STORE = 'Inpl.ads.console';
export const FORCE_AD_CONSOLE = 'Inpl.ads.forceConsole';

export const RELOAD_UANC_EVENT = 'Inpl.reloadUanc'; //globalny event wywołujący przeładowanie wstawki
export const UANC_CONFIG_EVENT = 'Inpl.Uanc.Config'; //globalny event informujący o gotowości konfiguracji reklam
export const ADS_LOADED_EVENT = 'Inpl.adsLoaded'; //globalny event informujący o gotowości usług adserwerów
export enum STATE_SERVICE {
    READY = 'READY', // gotowy
    REJECTED = 'REJECTED', // odrzucony - np. brak slotów do osadzenia z danych adserwerem
    PENDING = 'PENDING', // na starcie, oczekuje na ustawienie stanu - ready/reject w zależności od konfiguracji
}

export const APP_NAME = 'uanc';
export const TEST_CONFIG_API_ITG = '//api.interia.pl.itg.inpl.work/uanc/config?api-key=1b9987659a46c1';
export const TEST_CONFIG_API = '//api.interia.pl/uanc/config?api-key=f3f1182bdb8b3';

export enum AD_SERVERS {
    DFP = 'DFP',
    ADOCEAN = 'ADOCEAN',
}

export const SMART_LL: { [key: string]: { [key: string]: string[] } } = {
    '44520695/17interia/sgp2021': {
        halfpage_wydarzenia: ['b'],
    },
    '44520695/17interia/sgp2021_b': {
        halfpage_wydarzenia: ['b'],
    },
};

export enum AD_CONSOLE {
    UANC = 'uanc',
    VUANC = 'vuanc',
}

export enum AD_STATUS {
    LOADED = 'loaded',
    ART_SPONS = 'artSponsLoaded',
    EMPTY = 'empty',
}

export const SERVICES_GLOBAL_ENABLING = {
    [AD_SERVERS.DFP]: { isEnabled: true },
    [AD_SERVERS.ADOCEAN]: { isEnabled: true },
};

export const DEFAULT_MIN_ADS_REFRESH_INTERVAL = 30;
export const DEFAULT_ADS_REFRESH_INTERVAL: IRefreshAdsInterval = {
    enabled: true,
    interval: 30,
};

export const DSA_SLOT_PADDING_DEL = [
    '44520695/17interia/msg2021/dfp_',
    '44520695/17interia/sgp2021/dfp_box_oferty',
    '44520695/17interia/sgp2021/dfp_halfpage_oferty',
    '44520695/17interia/sgp2021/dfp_banner_',
];
export const DSA_SLOT_MIN_WIDTH = ['44520695/17interia/msg2021/dfp_'];
export const DSA_CONFIG: { [key: number | string]: string } = {
    1433918215:
        '<a href="https://site.adform.com/privacy-center/platform-privacy/product-and-services-privacy-policy/" target="_blank">Adform</a>',
    4475718232:
        '<a href="https://site.adform.com/privacy-center/platform-privacy/product-and-services-privacy-policy/" target="_blank">Adform</a>',
    4772133101: '<a href="https://www.xandr.com/privacy/platform-privacy-policy/" target="_blank">Xandr</a>',
    4567345159: '<a href="https://www.criteo.com/privacy/" target="_blank">Criteo</a>',
    1447027735: '<a href="https://equativ.com/end-users-privacy-policy/" target="_blank">Equativ</a>',
    1279036135: '<a href="https://business.safety.google/privacy/" target="_blank">Google</a>',
    1399169095: '<a href="https://business.safety.google/privacy/" target="_blank">Google</a>',
    '-1': '<a href="https://business.safety.google/privacy/" target="_blank">Google</a>',
    0: '<a href="https://business.safety.google/privacy/" target="_blank">Google</a>',
    4861661181: '<a href="https://www.indexexchange.com/privacy" target="_blank">Index Exchange</a>',
    5252664410: '<a href="https://www.magnite.com/legal/advertising-technology-privacy-policy/" target="_blank">Magnite</a>',
    1431711415: '<a href="https://pubmatic.com/legal/privacy/" target="_blank">PubMatic</a>',
    1430256055: '<a href="https://www.rtbhouse.com/privacy-center" target="_blank">RTB House</a>',
    4712116072: '<a href="https://www.teads.com/privacy-policy/" target="_blank">Teads</a>',
    5172117040: '<a href="https://www.businessclick.com/o-nas/" target="_blank">BusinessClick</a>',
    121764058: '<a href="https://optad360.com/privacy-policy/" target="_blank">Publishers Revenue Optimization</a>',
    5625831538: '<a href="https://adrino.pl/polityka-prywatnosci/" target="_blank">Adrino Mobile</a>',
    5728984778: '<a href="https://www.waytogrow.com/pl/polityka-prywatnosci/" target="_blank">Waytogrow</a>',
};

export const RODO_PERMISSION = ['rodo_1', 'rodo_3'];

export const MULTI_PLACE_SLOTS = ['box_sidebar', 'rectangle_news'];
